import { Component } from '@angular/core';
import { fadeInOutTransition } from '@order/pages/order-exceptions/animations/order-exception.animation';
import { SubstitutionRowBaseComponent } from '../../substitution-row-base.component';

@Component({
  selector: 'app-substitution-row-mobile',
  templateUrl: './substitution-row-mobile.component.html',
  styleUrls: ['./substitution-row-mobile.component.scss'],
  animations: [fadeInOutTransition],
})
export class SubstitutionRowMobileComponent extends SubstitutionRowBaseComponent {
  isExpanded = true;

  constructor() {
    super();
  }
}
